export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    // 球队列表
    getTeamsList: function getTeamsList(data) {
      return request({
        url: '/coach/getTeamsList',
        method: 'get',
        data: data
      });
    },
    //球队详情
    teamInfo: function teamInfo(data) {
      return request({
        url: '/coach/teamInfo',
        method: 'get',
        data: data
      });
    },
    //学生列表
    getStudentsList: function getStudentsList(data) {
      return request({
        url: '/coach/student/getStudentsList',
        method: 'get',
        data: data
      });
    },
    //能力标签
    getAbilityTagsList: function getAbilityTagsList(data) {
      return request({
        url: '/coach/ability/getAbilityTagsList',
        method: 'get',
        data: data
      });
    },
    //教练审核学生入队
    review: function review(data) {
      return request({
        url: '/coach/applications/review',
        method: 'post',
        data: data
      });
    },
    //添加能力标签
    addAbilityTags: function addAbilityTags(data) {
      return request({
        url: '/coach/ability/addAbilityTags',
        method: 'post',
        data: data
      });
    },
    //修改能力标签
    updateAbilityTags: function updateAbilityTags(data) {
      return request({
        url: '/coach/ability/updateAbilityTags',
        method: 'post',
        data: data
      });
    },
    //删除能力标签
    delAbilityTags: function delAbilityTags(data) {
      return request({
        url: '/coach/ability/delAbilityTags',
        method: 'post',
        data: data
      });
    },
    //修改学生信息
    changeStudentInfo: function changeStudentInfo(data) {
      return request({
        url: '/coach/student/changeStudentInfo',
        method: 'post',
        data: data
      });
    },
    //教练提交能力评价
    subAbility: function subAbility(data) {
      return request({
        url: '/coach/ability/subAbility',
        method: 'post',
        data: data
      });
    },
    //学生能力列表
    AbilityList: function AbilityList(data) {
      return request({
        url: '/coach/ability/AbilityList',
        method: 'get',
        data: data
      });
    },
    //训练计划列表
    trainingsList: function trainingsList(data) {
      return request({
        url: '/coach/trainingsList',
        method: 'get',
        data: data
      });
    },
    //新增训练计划
    trainingsAdd: function trainingsAdd(data) {
      return request({
        url: '/coach/trainingsAdd',
        method: 'post',
        data: data
      });
    },
    //更新训练计划
    trainingsUpd: function trainingsUpd(data) {
      return request({
        url: '/coach/trainingsUpd',
        method: 'post',
        data: data
      });
    },
    //取消训练计划
    trainingsCancel: function trainingsCancel(data) {
      return request({
        url: '/coach/trainingsCancel',
        method: 'post',
        data: data
      });
    },
    //删除训练计划
    trainingsDel: function trainingsDel(data) {
      return request({
        url: '/coach/trainingsDel',
        method: 'post',
        data: data
      });
    },
    //已报名学生列表
    studentList: function studentList(data) {
      return request({
        url: '/coach/trainings/studentList',
        method: 'get',
        data: data
      });
    },
    //已报名学生列表
    rating: function rating(data) {
      return request({
        url: '/coach/trainings/rating',
        method: 'post',
        data: data
      });
    },
    //评价学生
    commentStudent: function commentStudent(data) {
      return request({
        url: '/coach/student/commentStudent',
        method: 'post',
        data: data
      });
    },
    //赛事列表
    getTourList: function getTourList(data) {
      return request({
        url: '/coach/tour/getTourList',
        method: 'get',
        data: data
      });
    },
    //球队报名赛事
    register: function register(data) {
      return request({
        url: '/coach/tour/register',
        method: 'post',
        data: data
      });
    },
    //球队赛程列表
    matchList: function matchList(data) {
      return request({
        url: '/coach/tour/matchList',
        method: 'get',
        data: data
      });
    },
    //家长列表
    parentUserList: function parentUserList(data) {
      return request({
        url: '/user/parentUserList',
        method: 'get',
        data: data
      });
    },
    //教练给家长发送消息
    sendNotificationToParentUser: function sendNotificationToParentUser(data) {
      return request({
        url: '/coach/sendNotificationToParentUser',
        method: 'post',
        data: data
      });
    },
    //比赛阵容查看
    getLineup: function getLineup(data) {
      return request({
        url: '/matches/getLineup',
        method: 'get',
        data: data
      });
    },
    //获取比赛可用队员列表
    availablePlayers: function availablePlayers(data) {
      return request({
        url: '/coach/matches/available-players',
        method: 'get',
        data: data
      });
    },
    //保存比赛阵容
    lineup: function lineup(data) {
      return request({
        url: '/coach/matches/lineup',
        method: 'post',
        data: data
      });
    },
    disciplineStatus: function disciplineStatus(data) {
      return request({
        url: '/coach/students/discipline-status',
        method: 'get',
        data: data
      });
    }
  };
});